const {Component} = require("react");

class Loader extends Component {

	constructor(props) {
		super(props);

		this.state = {
			active: props.active || false
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.active !== this.state.active) {
			this.setState({active: nextProps.active});
		}
	}

	get className() {
		let classList = ["loader"];

		if (this.state.active) {
			classList.push("active");
		}

		return classList.join(" ");
	}

	activate() {
		this.setState({active: true});
		return this;
	}

	deactivate() {
		this.setState({active: false});
		return this;
	}

	get active() {
		return this.state.active;
	}

	render() {
		return (
			<div className={this.className}>{this.renderBody()}</div>
		);
	}

	renderBody() {
		return (
			<svg className="circle-loader" width="40" height="40" version="1.1" xmlns="http://www.w3.org/2000/svg">
				<circle cx="20" cy="20" r="8"/>
			</svg>
		);
	}
}

module.exports = Loader;


// WEBPACK FOOTER //
// ./resources/js/components/mixins/Loader.js